import _ from '@luna/lodash';

const getValueWithPartialValues = (value: string, partialValues: string[]): string =>
    `${value}=${partialValues.join('=')}`;

const getDecodedValueFromQuery = (query: string, param: string): string | null =>
    query.split('&').reduce((acc, varItem) => {
        const [key, value, ...partialValues] = varItem.split('=');
        const wholeValue = !_.isEmpty(partialValues)
            ? getValueWithPartialValues(value, partialValues)
            : value;

        if (decodeURIComponent(key) === param) {
            return decodeURIComponent(wholeValue);
        }

        return acc;
    }, '');

const getParamFromLocation = (windowLocation: Location, param: string): string | null => {
    const query = `${windowLocation.search.substring(1)}&${windowLocation.hash.substring(1)}`;

    return getDecodedValueFromQuery(query, param);
};

export const getParamFromHash = (param: string): string | null => {
    const query = window.location.hash.substring(1);

    return getDecodedValueFromQuery(query, param);
};

export const getParamFromSearchOrHash = (param: string): string | null =>
    getParamFromLocation(window.location, param);
